export default __webpack_public_path__ + "static/media/not-found.73319e4a.svg";